// frontend/src/components/calendars/TradingCalendar.js
import { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment-timezone';
import axios from 'axios';
import 'react-big-calendar/lib/css/react-big-calendar.css';

moment.tz.setDefault('Asia/Seoul');
const localizer = momentLocalizer(moment);

export default function TradingCalendar({ onSelectEvent, refreshKey = 0 }) {
  const [events, setEvents] = useState([]);
  const [date, setDate] = useState(new Date()); // 현재 날짜 상태
  const [view, setView] = useState('week'); // 기본 뷰 설정: day

  async function fetchCalendarData() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/data/trading_calendar/`,
      );
      const calendarData = response.data;

      const eventsMapped = calendarData.map((item) => ({
        // react-big-calendar용 필드
        id: item.id,
        title: item.event_description,
        start: moment(item.start_datetime).toDate(), // 항상 KST 기준 렌더링
        end: moment(item.end_datetime).toDate(),
        allDay: false,
        // 폼 편집용 원본 필드
        start_datetime: item.start_datetime,
        end_datetime: item.end_datetime,
        event_description: item.event_description,
        is_trading_enabled: item.is_trading_enabled,
      }));
      setEvents(eventsMapped);
    } catch (error) {
      console.error('Error fetching trading calendar data:', error);
      alert('거래 캘린더 데이터를 불러오는 중 오류가 발생했습니다.');
    }
  }

  useEffect(() => {
    // 초기 및 refreshKey 변경 시 호출
    fetchCalendarData();
  }, [refreshKey]);

  const handleRefresh = () => {
    fetchCalendarData();
  };

  const handleSelectEvent = (event) => {
    if (onSelectEvent) {
      // CalendarInputForm에서 그대로 사용할 수 있는 형태로 전달
      onSelectEvent(event);
    }
  };

  return (
    <div className='flex flex-col justify-center items-center mx-auto p-4'>
      <h2 className='text-2xl font-semibold text-neutral-900 p-4'>
        거래 불가 일정
      </h2>
      {/* 상단 타이틀 + 새로고침 버튼 */}
      <div className='flex items-center justify-end w-full max-w-[1200px] mb-4'>
        <button
          type='button'
          onClick={handleRefresh}
          className='inline-flex items-center rounded-md bg-sky-600 px-3 py-1.5
                     text-sm font-medium text-white shadow-sm
                     hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500'
        >
          새로고침
        </button>
      </div>

      <div className='h-[800px] w-[1200px] mx-auto shadow-sm bg-white'>
        <Calendar
          localizer={localizer}
          events={events}
          date={date} // controlled date prop
          view={view} // controlled view prop
          onNavigate={(newDate) => setDate(newDate)} // 날짜 변경 핸들러
          onView={(newView) => setView(newView)} // 뷰 변경 핸들러
          startAccessor='start'
          endAccessor='end'
          step={60}
          onSelectEvent={handleSelectEvent} // ← 이벤트 클릭 시 호출
          className='h-full w-full'
        />
      </div>
    </div>
  );
}
